export default "__VITE_ASSET__BUNHxBTN__"